export enum FormTypeEnum {
  Consent = 1,
  PostCare = 2,
  PreTreatment = 3,
  TreatmentInfo = 4,
  Intake = 5,
  Questionnaire = 6,
}
